import React from 'react'

export default function Counsellingfees(props) {
  return (
  <div className="col-md-6">
        <div className="forms ">
          <label for="fees">Fee for {props.record.id > 0 ? props.record.id : ""} Counselling</label>
          <input
            ref={props.txtBatchCFees}
            type="text"
            class="Inputs"
            id="fees"
            name="fees"
            placeholder="fees"
            value={props.record.fees < 0 ? 0 : props.record.fees}
            onChange={e => props.handleChangeCPanel(e, props.record.id)}
          />
           {props.record.error_8 && (
           <small className="error">{props.record.error_8}</small>)}
        </div>
      </div>
  )
}

